import { createSearchParamsBrackets } from '@lib/createSearchParamsBrackets'

// Backend limit from logs: 1024 * 10 = 10240 bytes
export const BACKEND_LIMIT = 10240
// Warning threshold: 70% of limit
export const WARNING_THRESHOLD = Math.floor(BACKEND_LIMIT * 0.7)

export type UrlLengthStatus = 'ok' | 'warning' | 'error'

export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes}B`
  }

  return `${(bytes / 1024).toFixed(1)}KB`
}

export function getUrlLengthStatus(length: number): UrlLengthStatus {
  if (length > BACKEND_LIMIT) return 'error'
  if (length > WARNING_THRESHOLD) return 'warning'

  return 'ok'
}

// Uses Record<string, unknown> because form values include DateRange objects
// that aren't in CleanDataObject but are handled at runtime by createSearchParamsBrackets
export function getProjectedUrlLength(origin: string, pathname: string, formData: Record<string, unknown>): number {
  const params = createSearchParamsBrackets(formData as Parameters<typeof createSearchParamsBrackets>[0])
  const query = params.toString()
  const projectedUrl = query ? `${origin}${pathname}?${query}` : `${origin}${pathname}`

  return projectedUrl.length
}
